import { METER_SEGMENTS } from '../lib/useAudioLevel';

/**
 * A segmented level ladder for one person's microphone.
 *
 * Segments rather than a continuous bar: it is the shape people already read as
 * a meter, it stays legible at tile size, and the quantisation is what keeps a
 * live meter from re-rendering the whole mosaic on every frame.
 *
 * Hidden from assistive tech on purpose — a value that changes several times a
 * second is noise to a screen reader, and the mic-on/off state it would
 * actually want is already in the tile's dot and label.
 */
export function MicMeter({ segments }: { segments: number }) {
  return (
    <span className="meter" aria-hidden="true">
      {Array.from({ length: METER_SEGMENTS }, (_, i) => (
        <span key={i} className={`meter-seg${i < segments ? ' lit' : ''}`} />
      ))}
    </span>
  );
}
